import React from "react";
import { FileDown } from "lucide-react";
import { fetchEpiReadyGuideDocument } from "../../lib/assistantApi.js";
import { saveEpiFile } from "./EpiDocument.jsx";

const FORMATS = [["pdf", "PDF"], ["docx", "Word"]];

// Guides prêts de la page ouverte : repliés derrière un bouton de l'en-tête, ils ne repoussent jamais la réponse.
export default function EpiReadyGuides({ guides }) {
  const rootRef = React.useRef(null);
  const [open, setOpen] = React.useState(false);
  const [pending, setPending] = React.useState("");
  const [error, setError] = React.useState("");
  React.useEffect(() => {
    if (!open) return undefined;
    const closeOutside = (event) => { if (!rootRef.current?.contains(event.target)) setOpen(false); };
    window.addEventListener("pointerdown", closeOutside);
    return () => window.removeEventListener("pointerdown", closeOutside);
  }, [open]);
  const download = async (slug, format) => {
    setPending(`${slug}:${format}`);
    setError("");
    try {
      saveEpiFile(await fetchEpiReadyGuideDocument(slug, format));
    } catch (failure) { setError(failure.message); }
    finally { setPending(""); }
  };
  return <div ref={rootRef}>
    <button aria-controls="epi-guides" aria-expanded={open} className="epi-guides-toggle" onClick={() => setOpen((value) => !value)} type="button">
      <FileDown aria-hidden="true" size={14} /><span className="epi-guides-toggle__long">Guides de cette page</span><span>· {guides.length}</span>
    </button>
    {open ? <div aria-label="Guides de cette page" className="epi-guides" id="epi-guides" role="group">
      <p>Guides prêts à imprimer, tirés tels quels du Guide du SaaS. Le téléchargement ne pose aucune question à Lumi.</p>
      {guides.map((guide) => <div className="epi-guide" key={guide.slug}>
        <div className="epi-guide__name">{guide.title}<span>{guide.steps} étape{guide.steps > 1 ? "s" : ""}</span></div>
        {FORMATS.map(([format, label]) => <button aria-label={`${guide.title} en ${label}`} disabled={Boolean(pending)} key={format}
          onClick={() => download(guide.slug, format)} type="button">{pending === `${guide.slug}:${format}` ? "…" : label}</button>)}
      </div>)}
      {error ? <p className="epi-error" role="alert">{error}</p> : null}
    </div> : null}
  </div>;
}
